import { BASE_URL, BUSINESS_NAME } from "@/core/constants/business";

export const META = {
  title: `Terms of Service | ${BUSINESS_NAME}`,
  meta_description: `Terms and conditions governing the use of ${BUSINESS_NAME}'s website and services. Review our legal agreement for purchasing cannabis products from our Washington DC dispensary.`,
  canonicalUrl: "/terms-of-service",
  keywords: `${BUSINESS_NAME} terms, cannabis dispensary terms of service, marijuana dispensary legal agreement, DC cannabis purchase terms, dispensary conditions of use, legal cannabis terms`,
};

export const generateTermsRichSnippet = () => {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${BASE_URL}/terms-of-service/#webpage`,
    url: `${BASE_URL}/terms-of-service/`,
    name: META.title,
    description: META.meta_description,
    isPartOf: {
      "@id": `${BASE_URL}/#website`,
    },
    about: {
      "@type": "Organization",
      name: BUSINESS_NAME,
      url: BASE_URL,
    },
    mainContentOfPage: {
      "@type": "WebPageElement",
      cssSelector: ".terms-content",
    },
    speakable: {
      "@type": "SpeakableSpecification",
      cssSelector: ["h1", "h2", ".terms-intro"],
    },
  };
};
